export const BRAND = {
  name: "On This Rock",
  suffix: "LLC",
  logo: "/images/logo.png",
  email: "Q@onthisrock.org",
  phone: "630-708-0255",
  phoneHref: "tel:+16307080255",
  address: "Aurora, Illinois 60506",
  tagline: "Safety. Compliance. Built to last.",
};

export const IMAGES = {
  hero: "/images/hero.jpg",
  about: "/images/founder.jpg",
  osha: "/images/osha.jpg",
  keynote: "/images/keynote.jpg",
  energy: "/images/energy.jpg",
  books: "/images/books.jpg",
};

export const CREDENTIALS = [
  { value: "40+", label: "Years in Construction & General Industry" },
  { value: "OSHA", label: "Authorized Outreach Trainer" },
  { value: "NCCER", label: "Master Trainer & Evaluator" },
  { value: "HBI", label: "Master Trainer & Evaluator" },
];

export const PILLARS = [
  {
    key: "individual",
    title: "Individual Training",
    interest: "Individual Training",
    desc: "Career-focused OSHA 10 & 30 certification for workers, supervisors, and job seekers ready to advance.",
    icon: "UserRound",
  },
  {
    key: "corporate",
    title: "Corporate Training",
    interest: "Corporate Training",
    desc: "On-site and ongoing safety programs that protect your crews, your projects, and your bottom line.",
    icon: "Building2",
  },
  {
    key: "osha",
    title: "OSHA 10 / 30 — In-Person & Virtual",
    interest: "OSHA 10 / 30 (In-Person)",
    desc: "Authorized Outreach training delivered live in the classroom or virtually, with certification exam included.",
    icon: "ShieldCheck",
  },
  {
    key: "keynote",
    title: "Keynote & Breakout Sessions",
    interest: "Keynote / Breakout Session",
    desc: "Engaging keynotes and breakout sessions on safety culture, leadership, and overcoming self-sabotage.",
    icon: "Mic",
  },
];

export const PRICING = {
  nonAffiliate: {
    label: "Non-Affiliate",
    note: "Open enrollment for individuals & companies",
    plans: [
      {
        name: "OSHA 10/30 — Two-Day",
        price: "$259",
        unit: "/ student",
        features: [
          "Two 5-hour classroom sessions",
          "Water & snacks provided",
          "Certification review + exam",
          "One-year expiration date",
          "Fri & Sat (AM or PM track)",
        ],
      },
    ],
  },
  affiliate: {
    label: "Affiliate",
    note: "Discounted rates for affiliate partners",
    plans: [
      {
        name: "OSHA 10/30 — Two-Day",
        price: "$209",
        unit: "/ student",
        features: [
          "Two 5-hour classroom sessions",
          "Water & snacks provided",
          "Certification review + exam",
          "One-year expiration date",
          "Affiliate partner pricing",
        ],
      },
    ],
  },
};

export const AFFILIATE_TIERS = [
  { range: "0 – 50 Employees", price: "$500", per: "/ month", visits: "1 monthly visit" },
  { range: "50 – 75 Employees", price: "$750", per: "/ month", visits: "1 monthly visit" },
  { range: "75 – 100 Employees", price: "$1,000", per: "/ month", visits: "1 visit + designated walk" },
  { range: "100 – 150 Employees", price: "$1,500", per: "/ month", visits: "1 visit + designated walk" },
  { range: "150 – 200 Employees", price: "$2,000", per: "/ month", visits: "1 visit + designated walk" },
  { range: "200+ Employees", price: "$2,000 +$10/ee", per: "/ month", visits: "2 visits + 2 walks" },
];

export const MEVSME = {
  name: "Me vs Me",
  url: "https://mevsmes.com",
  tagline: "Become the next version of you.",
  intro:
    "A companion app to the mission of On This Rock — timeless principles translated into practical, daily guidance. No verses, no preaching. Just wisdom that has shaped lives for two millennia, made practical for yours.",
  whisper:
    "The soul that carries no offense walks further than the one burdened with being right.",
  image: "/images/mevsme.jpg",
  pillars: [
    { title: "Acceptance", desc: "Make peace with what is — without surrendering who you're becoming." },
    { title: "Forgiveness", desc: "Release what you hold so it stops holding you." },
    { title: "Wisdom", desc: "Turn lived experience into quiet, confident action." },
    { title: "Leadership", desc: "Lead yourself first. The rest will follow." },
  ],
  steps: [
    "Receive a daily principle — grounded truth, delivered plainly.",
    "Ask anything that troubles you and get principle-based guidance.",
    "Journal the me vs me — track the version of you you're becoming.",
  ],
};

export const BOOKS = [
  {
    title: "Aliens in America",
    subtitle: "A System Within a System",
    desc: "An unflinching look at the systems operating beneath the systems we think we know — and how to navigate them with clarity and purpose.",
    tag: "Society & Systems",
  },
  {
    title: "Adam, Where Are You?",
    subtitle: "The Journey Through Self-Sabotage",
    desc: "A personal roadmap out of self-sabotage and back to accountability, identity, and the foundation worth building your life on.",
    tag: "Personal Growth",
  },
];

export const INTERESTS = [
  "Individual Training",
  "Corporate Training",
  "OSHA 10 / 30 (In-Person)",
  "OSHA 10 / 30 (Virtual)",
  "Keynote / Breakout Session",
  "Affiliate Safety Program",
  "Clean Energy (Coming 2026)",
  "Books / Speaking",
  "Other",
];

export const PAYPAL = {
  clientId:
    "BAAnfdUxadQzp6xb-W3NsGFgkeEAHizxJ2cZsSb_2O7_80rcpoFcD9XaE3ur61oTEVs4Q8LlBXm_mnrJOk",
};

export const CONSULTATION_TYPES = [
  {
    id: "free",
    label: "Discovery Call",
    duration: 15,
    price: 0,
    blurb: "Quick intro & needs assessment",
  },
  {
    id: "standard",
    label: "Standard Session",
    duration: 30,
    price: 99,
    hostedButtonId: "BH2ARDKZLMMPQ",
    blurb: "Focused 30-minute working session",
  },
  {
    id: "deep",
    label: "Deep-Dive Session",
    duration: 60,
    price: 199,
    hostedButtonId: "C8MDZYLM6YCMN",
    blurb: "Comprehensive 60-minute strategy session",
  },
];

export const AVAILABILITY = {
  days: [1, 2, 3, 4], // Mon, Tue, Wed, Thu
  startHour: 9, // 9:00 AM
  endHour: 16, // last slot 4:30 PM (endHour:30)
  slotMinutes: 30,
  durationMinutes: 15,
  ownerTimeZone: "America/Chicago",
};

export const TIMEZONES = [
  { value: "America/Chicago", label: "Central (Chicago)" },
  { value: "America/New_York", label: "Eastern (New York)" },
  { value: "America/Indiana/Indianapolis", label: "Indiana (Indianapolis)" },
  { value: "America/Denver", label: "Mountain (Denver)" },
  { value: "America/Phoenix", label: "Arizona (Phoenix)" },
  { value: "America/Los_Angeles", label: "Pacific (Los Angeles)" },
  { value: "Africa/Accra", label: "Ghana (Accra)" },
];
